import PropTypes from "prop-types";
import React, { Component } from "react";
import ContextContent from "../Context/ContextContent";
export default class DropdownContent extends Component {
  render() {
    return /*#__PURE__*/React.createElement(ContextContent, this.props);
  }
}